import { getReportBySlug } from "@/assets/reports.config";

const REPORTS_ENDPOINT = "/analytics/reports";


function extractApiError(err) {
  const body = err && err.response && err.response.data;
  if (!body) return err;
  const enriched = new Error(body.message || "Error al obtener el reporte.");
  enriched.statusCode = err.response.status;
  enriched.validationErrors = body.info && Array.isArray(body.info.errors)
    ? body.info.errors
    : null;
  return enriched;
}

const state = () => ({
  activeFilters: {}
});

const mutations = {
  resetReports(state) {
    state.activeFilters = {};
  },
  SET_FILTERS(state, { slug, filters }) {
    state.activeFilters = {
      ...state.activeFilters,
      [slug]: { ...(filters || {}) }
    };
  }
};

const actions = {
  async fetchReport({ commit }, { slug, filters = {} } = {}) {
    const reportConfig = getReportBySlug(slug);
    if (!reportConfig) {
      throw new Error(`Report config not found for slug "${slug}"`);
    }

    commit("SET_FILTERS", { slug, filters });

    let data;
    if (reportConfig.mock) {
      await new Promise(resolve => setTimeout(resolve, 400));
      const allRows = typeof reportConfig.mockData === "function"
        ? reportConfig.mockData(filters)
        : Array.isArray(reportConfig.mockData)
          ? reportConfig.mockData
          : [];
      if (reportConfig.paginated) {
        const page = parseInt(filters.page) || 1;
        const pageSize = parseInt(filters.page_size) || reportConfig.defaultPageSize || 50;
        const start = (page - 1) * pageSize;
        data = {
          rows: allRows.slice(start, start + pageSize),
          total: allRows.length,
          meta: { page, page_size: pageSize, total: allRows.length },
          summary: {}
        };
      } else {
        data = allRows;
      }
    } else {
      try {
        const response = await this.$axios.post(REPORTS_ENDPOINT, { report: slug, filters });
        const payload = response && response.data !== undefined ? response.data : response;
        const rows = Array.isArray(payload.data) ? payload.data : [];
        const meta = payload.meta || {};

        if (reportConfig.paginated) {
          data = {
            rows,
            total: meta.total != null ? meta.total : rows.length,
            meta,
            summary: payload.summary || payload.totals || {},
            dynamicColumns: Array.isArray(payload.dynamic_columns) ? payload.dynamic_columns : null
          };
        } else {
          data = rows;
        }
      } catch (err) {
        throw extractApiError(err);
      }
    }

    return data;
  }
};

const getters = {
  reportFilters: state => slug => state.activeFilters[slug] || {}
};

export default {
  state,
  mutations,
  actions,
  getters
};
